import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { Callout } from '../../../classes/models/callout.model';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var SketchViewModel;
var SimpleFillSymbol;
var pixelsInAPoint = 1.3333;
var widthPaddingMultiplier = 2;
var sketchUpdateTimeout = 10;
var initilizeDebounceTime = 50;
var CalloutComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CalloutComponent, _super);
    function CalloutComponent(_vcr, changeDetectorRef, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.layerService = layerService;
        _this._active = false;
        _this.showImageUpload = false;
        _this.activeChange = new EventEmitter();
        _this.callouts = [];
        _this.layerName = 'Callouts';
        _this.boxAlignmentOptions = ['Top Left', 'Bottom Left', 'Top Right', 'Bottom Right'];
        _this.outlineMin = 0;
        _this.outlineMax = 10;
        _this.textSizeMin = 8;
        _this.textSizeMax = 128;
        _this.loaded = false;
        _this.doAddCallout = false;
        _this.selectedImage = null;
        _this.cbImageSource = null;
        _this.imageOn = false;
        _this.initializing = false;
        _this.listners = [];
        _this.registerEvent('activeChange', _this.activeChange);
        return _this;
    }
    Object.defineProperty(CalloutComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = value;
            value ? this.activate() : this.deactivate();
            this.activeChange.emit(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalloutComponent.prototype, "fillColorPickerRef", {
        set: function (el) { this.fillColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalloutComponent.prototype, "outlineColorPickerRef", {
        set: function (el) { this.outlineColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalloutComponent.prototype, "textColorPickerRef", {
        set: function (el) { this.textColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    CalloutComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, err_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _c.sent();
                        this.mapView.watch('scale', this.onScaleChange.bind(this));
                        return [4 /*yield*/, Promise.all([ESRI.Graphic, ESRI.SketchViewModel, ESRI.SimpleFill])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 3]), Graphic = _a[0], SketchViewModel = _a[1], SimpleFillSymbol = _a[2];
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CalloutComponent.prototype.initSketch = function () {
        this.sketchViewModel = new SketchViewModel({
            layer: this.activeCallout.graphicsLayer,
            defaultUpdateOptions: {
                enableRotation: false,
                multipleSelectionEnabled: false,
                toggleToolOnClick: false
            },
            updateOnGraphicClick: false,
            view: this.mapView,
            polygonSymbol: this.activeCallout.calloutGraphic.symbol.clone()
        });
        this.sketchViewModel.on('update', this.sketchUpdate.bind(this));
    };
    CalloutComponent.prototype.teardownSketch = function () {
        if (this.sketchViewModel) {
            this.sketchViewModel.complete();
            this.sketchViewModel.destroy();
            this.sketchViewModel = null;
        }
    };
    CalloutComponent.prototype.onScaleChange = function () {
        var _this = this;
        if (this.sketchViewModel) {
            setTimeout(function () { return _this.resetSketch(false); }, sketchUpdateTimeout);
        }
    };
    /**
     * Make the tool active/shown.
     */
    CalloutComponent.prototype.activate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.mapClickListener) {
                    this.mapClickListener = this.mapView.on('click', function (evt) { return _this.handleMapClick(evt); });
                }
                this.setupHandleHiddenLayer();
                this.doAddCallout = true;
                this.callouts = Callout.fromLayers(this.layerService.mapLayers.graphics);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Make the tool inactive/hidden.
     */
    CalloutComponent.prototype.deactivate = function () {
        this.activeCallout = null;
        this.teardownHandleHiddenLayer();
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
        }
        if (this.sketchViewModel) {
            this.teardownSketch();
        }
        this.loaded = false;
    };
    CalloutComponent.prototype.handleMapClick = function (evt) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var screenPoint, response, graphic_1, matchingCallout, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!evt.mapPoint) return [3 /*break*/, 7];
                        screenPoint = {
                            x: evt.x,
                            y: evt.y
                        };
                        return [4 /*yield*/, this.mapView.hitTest(screenPoint)];
                    case 1:
                        response = _b.sent();
                        if (!response.results.length) return [3 /*break*/, 2];
                        graphic_1 = response.results[0].graphic;
                        matchingCallout = this.callouts.find(function (c) { return c.id === graphic_1.attributes.id; });
                        if (matchingCallout) {
                            if (this.activeCallout && matchingCallout.id !== this.activeCallout.id) {
                                this.teardownSketch();
                            }
                            this.activeCallout = matchingCallout;
                            //if the callout being selected has an image, update these properties
                            if (this.activeCallout.pictureMarkerSymbolProperties && this.activeCallout.pictureMarkerSymbolProperties.url) {
                                this.cbImageSource = this.activeCallout.pictureMarkerSymbolProperties.url;
                                this.imageOn = true;
                            }
                            this.doAddCallout = false;
                            this.setEditing();
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        if (!this.doAddCallout) return [3 /*break*/, 5];
                        this.doAddCallout = false;
                        this.activeCallout = new Callout(evt.mapPoint);
                        this.callouts.push(this.activeCallout);
                        _a = this.activeCallout;
                        return [4 /*yield*/, this.getGraphicLayer(this.getGraphics(this.activeCallout))];
                    case 3:
                        _a.graphicsLayer = _b.sent();
                        this.cbImageSource = null;
                        this.imageOn = false;
                        return [4 /*yield*/, this.activeCallout.graphicsLayer.when()];
                    case 4:
                        _b.sent();
                        this.setEditing();
                        return [3 /*break*/, 6];
                    case 5:
                        this.activeCallout = null;
                        this.doAddCallout = true;
                        this.teardownSketch();
                        _b.label = 6;
                    case 6:
                        this.changeDetectorRef.detectChanges();
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CalloutComponent.prototype.sketchUpdate = function (e) {
        if (this.activeCallout && this.activeCallout.textGraphic && this.activeCallout.calloutGraphic) {
            this.activeCallout.textGraphic.geometry = this.activeCallout.calloutGraphic.geometry.centroid.clone();
            var _a = this.activeCallout.symbolProperties, type = _a.type, symbolProperties = tslib_1.__rest(_a, ["type"]);
            this.activeCallout.calloutGraphic.symbol = new SimpleFillSymbol(symbolProperties);
            this.activeCallout.graphicsLayer.graphics.reorder(this.activeCallout.textGraphic, 1);
        }
        /* TODO: Implement callout box pseudo-anchor point */
        if (e.toolEventInfo && (e.toolEventInfo.type === 'move-stop' || e.toolEventInfo.type === 'scale-stop')) {
            this.activeCallout.setGeometry(this.mapView.scale);
            if (e.toolEventInfo.type === 'scale-stop' && this.prevMapPointX) {
                this.activeCallout.mapPoint.x = this.prevMapPointX;
            }
            this.updateGraphic(this.activeCallout);
            this.changeDetectorRef.detectChanges();
        }
    };
    CalloutComponent.prototype.setEditing = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.activeCallout) return [3 /*break*/, 2];
                        this.initSketch();
                        return [4 /*yield*/, this.resetSketch()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.teardownSketch();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CalloutComponent.prototype.resetSketch = function (fireRefreshLayers) {
        if (fireRefreshLayers === void 0) { fireRefreshLayers = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sketchViewModel.cancel();
                        this.initializing = true;
                        return [4 /*yield*/, this.sketchViewModel.update(this.activeCallout.calloutGraphic, { tool: 'transform' })];
                    case 1:
                        _a.sent();
                        this.sketchViewModel.activeComponent.layer.mapcoreProps = { hideInLegend: true };
                        if (fireRefreshLayers && this.loaded) {
                            this.layerService.refreshLayers();
                        }
                        this.loaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    CalloutComponent.prototype.getGraphics = function (callout) {
        callout.calloutGraphic = new Graphic({
            attributes: {
                type: 'callout',
                part: 'box',
                id: callout.id,
                boxAlignment: callout.boxAlignment,
                tailSize: callout.tailSize,
                boxWidth: callout.boxWidth,
                boxHeight: callout.boxHeight,
                cornerRadius: callout.cornerRadius
            },
            geometry: {
                type: 'polygon',
                rings: callout.getGeometry(this.mapView.scale),
                spatialReference: this.mapView.spatialReference
            },
            symbol: callout.symbolProperties
        });
        if (this.imageOn) {
            callout.textGraphic = new Graphic({
                attributes: {
                    type: 'callout',
                    part: 'image',
                    id: callout.id
                },
                geometry: callout.calloutGraphic.geometry.centroid.clone(),
                symbol: this.getPictureMarkerSymbolProperties(callout)
            });
            if (!callout.textGraphic.symbol.height) {
                callout.textGraphic.symbol.height = 200;
            }
            if (!callout.textGraphic.symbol.width) {
                callout.textGraphic.symbol.width = 200;
            }
        }
        else {
            callout.textGraphic = new Graphic({
                attributes: {
                    type: 'callout',
                    part: 'text',
                    id: callout.id
                },
                geometry: callout.calloutGraphic.geometry.centroid.clone(),
                symbol: this.getTextSymbolProperties(callout)
            });
        }
        return [callout.calloutGraphic, callout.textGraphic];
    };
    CalloutComponent.prototype.getTextSymbolProperties = function (callout) {
        var textOffset = callout.getTextOffset();
        return tslib_1.__assign({ type: 'text', xoffset: textOffset.x, yoffset: textOffset.y, lineWidth: (callout.boxWidth - (callout.horizontalPadding * widthPaddingMultiplier)) / pixelsInAPoint }, callout.textProperties);
    };
    CalloutComponent.prototype.getPictureMarkerSymbolProperties = function (callout) {
        var textOffset = callout.getTextOffset();
        return tslib_1.__assign({ type: 'picture-marker', xoffset: textOffset.x, yoffset: textOffset.y, lineWidth: (callout.boxWidth - (callout.horizontalPadding * widthPaddingMultiplier)) / pixelsInAPoint }, callout.pictureMarkerSymbolProperties);
    };
    CalloutComponent.prototype.getGraphicLayer = function (graphics) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: "Callout " + this.callouts.length, graphics: graphics }, { identifyEnabled: false })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CalloutComponent.prototype.updateGraphic = function (callout) {
        if (!this.prevMapPointX) {
            this.prevMapPointX = this.activeCallout.calloutGraphic.geometry.rings[0][0][0];
        }
        callout.normalizeMinMax();
        var updatedGraphics = this.getGraphics(callout);
        callout.graphicsLayer.graphics.removeAll();
        callout.graphicsLayer.graphics.addMany(updatedGraphics);
        if (this.sketchViewModel && this.sketchViewModel.state !== 'disabled') {
            this.resetSketch();
        }
        this.prevMapPointX = updatedGraphics[0].geometry.rings[0][0][0];
        this.changeDetectorRef.detectChanges();
    };
    CalloutComponent.prototype.setupHandleHiddenLayer = function () {
        var _this = this;
        this.initializing = true;
        var stopInitialCheck = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
            if (_this.initializing && event.item.listMode === 'hide') {
                event.item.set('hideInLegend', true);
                event.item.set('calloutToolGeneratedLayer', true);
                stopInitialCheck();
            }
        }));
        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
            if (event.item.get('calloutToolGeneratedLayer')) {
                _this.initializing = true;
            }
        }));
    };
    CalloutComponent.prototype.teardownHandleHiddenLayer = function () {
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    CalloutComponent.prototype.onFileSelected = function (event) {
        var _this = this;
        //store image
        if (event.target.files.length === 0 || event.target.files.length > 1) {
            return;
        }
        this.selectedImage = event.target.files[0];
        //read file and update img src to display image
        var fr = new FileReader();
        fr.readAsDataURL(this.selectedImage);
        fr.onload = function (_event) {
            _this.cbImageSource = fr.result;
            _this.imageOn = true;
            _this.activeCallout.pictureMarkerSymbolProperties.url = _this.cbImageSource;
            if (_this.activeCallout.boxHeight < 300) {
                _this.activeCallout.boxHeight = 300;
                _this.activeCallout.calloutGraphic.attributes.boxHeight = 300;
            }
            if (_this.activeCallout.boxWidth < 300) {
                _this.activeCallout.boxWidth = 300;
                _this.activeCallout.calloutGraphic.attributes.boxWidth = 300;
            }
            _this.updateGraphic(_this.activeCallout);
        };
    };
    CalloutComponent.prototype.removeImage = function () {
        if (this.cbImageSource) {
            this.cbImageSource = null;
            this.imageOn = false;
            this.activeCallout.pictureMarkerSymbolProperties.url = null;
            this.updateGraphic(this.activeCallout);
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], CalloutComponent.prototype, "showImageUpload", void 0);
    return CalloutComponent;
}(BaseComponent));
export { CalloutComponent };
